var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 20,
    height: 20,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15976 6.15976C6.37277 5.94675 6.71814 5.94675 6.93115 6.15976L10 9.22861L13.0689 6.15976C13.2819 5.94675 13.6272 5.94675 13.8402 6.15976C14.0533 6.37277 14.0533 6.71814 13.8402 6.93115L10.7714 10L13.8402 13.0689C14.0533 13.2819 14.0533 13.6272 13.8402 13.8402C13.6272 14.0533 13.2819 14.0533 13.0689 13.8402L10 10.7714L6.93115 13.8402C6.71814 14.0533 6.37277 14.0533 6.15976 13.8402C5.94675 13.6272 5.94675 13.2819 6.15976 13.0689L9.22861 10L6.15976 6.93115C5.94675 6.71814 5.94675 6.37277 6.15976 6.15976Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-file-icon.fc71e01b9f0122e94bda2540cf308026.svg";